import { render, staticRenderFns } from "./menuPower.vue?vue&type=template&id=715dafca&"
import script from "./menuPower.vue?vue&type=script&lang=js&"
export * from "./menuPower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports